import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import MovieCard from '../movie-card/MovieCard';
import './ranked-movie-list.scss';

const RankedMovieList = ({ country, genreId, type, size = 10 }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const swiperRef = useRef(null);

    useEffect(() => {
        let url;
        if (country) {
            url = `/movies-public-api.php?type=byCountry&country=${encodeURIComponent(country)}&page=0&size=${size}`;
        } else if (genreId) {
            url = `/movies-public-api.php?type=byGenre&genreId=${genreId}&page=0&size=${size}`;
        } else if (type) {
            // VD type="trending" → bảng xếp hạng "Xem nhiều trong tuần" theo lượt xem thật
            url = `/movies-public-api.php?type=${encodeURIComponent(type)}&page=0&size=${size}`;
        } else return;

        setLoading(true);
        fetch(url)
            .then(r => r.json())
            .then(d => { if (d.success) setItems(d.content || []); })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [country, genreId, type, size]);

    const updateNav = s => { setIsBeginning(s.isBeginning); setIsEnd(s.isEnd); };

    if (loading) return <div style={{ padding: '20px 0', color: '#555' }}>Loading...</div>;
    if (!items.length) return null;

    return (
        <div className="ranked-list">
            {!isBeginning && (
                <button className="ranked-list__nav ranked-list__nav--prev" onClick={() => swiperRef.current?.slidePrev()}>
                    <FaChevronLeft />
                </button>
            )}
            {!isEnd && (
                <button className="ranked-list__nav ranked-list__nav--next" onClick={() => swiperRef.current?.slideNext()}>
                    <FaChevronRight />
                </button>
            )}
            <Swiper
                grabCursor
                spaceBetween={0}
                slidesPerView="auto"
                onSwiper={s => { swiperRef.current = s; updateNav(s); }}
                onSlideChange={updateNav}
            >
                {items.map((item, i) => (
                    <SwiperSlide key={item.id} className="ranked-slide">
                        <div className="ranked-card">
                            <span className={`ranked-card__num${(i + 1) >= 10 ? ' ranked-card__num--two' : ''}`}>{i + 1}</span>
                            <div className="ranked-card__movie">
                                <MovieCard item={{
                                    id: item.id,
                                    title: item.title,
                                    poster_path: item.posterUrl,
                                    backdrop_path: item.thumbnailUrl || item.posterUrl,
                                    slug: item.slug,
                                    releaseYear: item.releaseYear,
                                    duration: item.duration,
                                    averageRating: item.averageRating,
                                    episodeCount: item.episodeCount,
                                    status: item.status,
                                    genres: item.genres,
                                    description: item.description,
                                    country: item.country,
                                }} />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default RankedMovieList;
